<template>
  <el-dialog title="Thông báo" :visible.sync="localVisible" width="520px" :append-to-body="false">
    <div>
      Hiện tại hệ thống không còn bài tập phù hợp để làm mới.
    </div>
    <span slot="footer" class="dialog-footer">
      <button class="btn btn-light-gray font-weight-bold mr-2" @click="close">
        <i class="fas fa-times"></i> Đóng
      </button>
    </span>
  </el-dialog>
  
</template>

<script>
export default {
  name: 'NoHomeworkRefreshDialog',
  props: {
    visible: { type: Boolean, default: false },
  },
  computed: {
    localVisible: {
      get() { return this.visible; },
      set(v) { this.$emit('update:visible', v); }
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
</style>


